import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Users",
  "use": "Users-usage",
  "viewBox": "0 0 20 14",
  "content": "<symbol viewBox=\"0 0 20 14\" id=\"Users\"><path d=\"M14.5 7c1.38 0 2.49-1.12 2.49-2.5S15.88 2 14.5 2a2.5 2.5 0 0 0 0 5zM7 6c1.66 0 2.99-1.34 2.99-3S8.66 0 7 0C5.34 0 4 1.34 4 3s1.34 3 3 3zm7.5 2.65c-1.83 0-5.5.92-5.5 2.75v2.25h11V11.4c0-1.83-3.67-2.75-5.5-2.75zm-7.5-1c-2.33 0-7 1.17-7 3.5v2.5h7V11.4c0-.85.33-2.34 2.37-3.47-.87-.18-1.71-.28-2.37-.28z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol